import type { CoverageStats } from '@mollusk/shared';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { STAT_DEFINITIONS } from '../home/HomeView';

/** Permits-coverage headline (#171): the same numbers and definitions as Home. */
export function CoverageStatsHeadline({ stats }: { stats: CoverageStats | undefined }) {
  const s = stats;
  const big = s?.large_cities;
  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'center' }}>
        <Tooltip title={STAT_DEFINITIONS.people} arrow>
          <Box sx={{ cursor: 'help' }}>
            <Typography variant="h4" color="primary">
              {s ? `${Math.round(s.people_covered / 1_000_000)}M people` : '—'}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              covered{s ? `, ${Math.round(s.share_covered * 100)}% of the US` : ''}
            </Typography>
          </Box>
        </Tooltip>
        <Divider orientation="vertical" flexItem />
        <Tooltip title={STAT_DEFINITIONS.permits} arrow>
          <Box sx={{ cursor: 'help' }}>
            <Typography variant="h4">{s ? s.permits_on_record.toLocaleString() : '—'}</Typography>
            <Typography variant="caption" color="text.secondary">
              permits on record
            </Typography>
          </Box>
        </Tooltip>
      </Box>
      {big ? (
        <Tooltip title={STAT_DEFINITIONS.cities} arrow>
          <Typography sx={{ mt: 1, cursor: 'help', display: 'inline-block' }}>
            {`${big.over100k.ok} of the ${big.over100k.total} cities over 100,000 people, and ${big.top10.ok} of the ${big.top10.total} largest, have current permit data`}
          </Typography>
        </Tooltip>
      ) : null}
      <Typography variant="body2" color="text.secondary">
        Data as of {s?.as_of ?? '—'}
      </Typography>
    </Box>
  );
}
